export default __webpack_public_path__ + "static/media/downredrow.adb02ead.svg";